module.exports = __webpack_public_path__ + "static/img/mouvement-curseur.e96028b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/instructions/img/mouvement-curseur.gif
// module id = oQgl
// module chunks = 0